/* unplugin-vue-components disabled */import script from "./ArticlePreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlePreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./ArticlePreviewModal.vue?vue&type=style&index=0&id=78ff79bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ff79bc"]])

export default __exports__